import * as React from 'react';
import { Head } from '@inertiajs/react';

interface SEOBlockProps {
  appUrl: string;
}

export function SEOBlock({ appUrl }: SEOBlockProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Abasto Virtual',
    description: 'Proveedor de frutas y verduras frescas para colegios, jardines y universidades en Córdoba. Entrega programada, facturación formal y precios mayoristas.',
    url: `${appUrl}/educacion`,
    telephone: '+5493512026384',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Córdoba',
      addressRegion: 'Córdoba',
      addressCountry: 'AR',
    },
    areaServed: {
      '@type': 'City',
      name: 'Córdoba',
    },
    priceRange: '$$',
  };

  return (
    <>
      <Head>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Head>
      <section className="edu-seo">
        <style>{`
          .edu-seo {
            padding: 48px 24px;
            background: #fafaf7;
            border-top: 1px solid #eee;
          }
          .edu-seo-inner {
            max-width: 720px;
            margin: 0 auto;
          }
          .edu-seo h2 {
            font-size: 20px;
            font-weight: 700;
            color: #666;
            margin: 0 0 12px;
          }
          .edu-seo p {
            font-size: 15px;
            color: #888;
            line-height: 1.7;
            margin: 0;
          }
        `}</style>
        <div className="edu-seo-inner">
          <h2>Proveedor de frutas y verduras para instituciones educativas en Córdoba</h2>
          <p>
            Abasto Virtual provee frutas y verduras frescas a colegios, escuelas, jardines de infantes
            y universidades en Córdoba. Entrega programada, facturación formal, precios mayoristas
            y calidad constante para comedores escolares.
          </p>
        </div>
      </section>
    </>
  );
}
